import { debounce, doSpinnerByLoadingId } from "../utils/utils";
require("./expandable-menu/expandable-nav");
FundPagesCommon();

// Reapplying button event listener after carousel initializes and resizes if how to buy carousel exists on the page (needed for use in slick carousel elements as carousel refresh removes the event listeners of the elements within it - WEBEU2359)
if (document.querySelector(".how-to-buy .carousel-block__main")) {
   const carouselMain = document.querySelector(".how-to-buy .carousel-block__main");
   
   const carouselEventHandler = (e) => {
       e.currentTarget.querySelectorAll(".fund-data-row__main-content .cta-button").forEach(button => {
           button.addEventListener("click", (e) => {
               e.preventDefault();
               veBrokerClickOut.ticker = veBrokerClickOut.getTicker(e);
               const modal = document.getElementById("id-how-to-buy-etf-modal");
               if (modal) {
                   const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
                   bsModal.show();
               }
           });
       });
   };
   
   // Bootstrap or slick carousel events need to be observed
   const observer = new MutationObserver(() => {
       carouselEventHandler({ currentTarget: carouselMain });
   });
   
   observer.observe(carouselMain, { attributes: true });
   
   window.addEventListener("resize", debounce(() => {
       document.querySelectorAll(".fund-data-row__main-content .cta-button").forEach(button => {
           button.addEventListener("click", (e) => {
               e.preventDefault();
               veBrokerClickOut.ticker = veBrokerClickOut.getTicker(e);
               const modal = document.getElementById("id-how-to-buy-etf-modal");
               if (modal) {
                   const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
                   bsModal.show();
               }
           });
       });
   }, 300));
}

function FundPagesCommon() {
   if(window.FundPagesCommonScriptsLoaded) return;
   window.FundPagesCommonScriptsLoaded = true;

   window.veBrokerClickOut = {
       ticker: "",
       currentPage: window.location.href,
       APIURL: "/Main/BrokerListing/GetBrokerData",
       APIDisclaimerURL: "/Main/BrokerListing/GetBrokerDisclaimer",
       countryISO: window.location.pathname?.split("/")[1]?.toUpperCase(),

       getTicker: (e) => {
           // Multi product pages
           // Read ticker from data attribute of button container element
           const fundDataRow = e.target.closest(".fund-data-row__main-content");
           if (fundDataRow && fundDataRow.dataset.tickerBtn !== undefined) 
               return fundDataRow.dataset.tickerBtn;

           // Single React fund pages
           // Read ticker from veFundInformation object property
           if (typeof veFundInformation == "object" && veFundInformation.portfolioTicker) 
               return veFundInformation.portfolioTicker;
               
           // Read ticker from ve-fundticker element text
           const fundTicker = document.querySelector('ve-fundticker');
           if (fundTicker) 
               return fundTicker.textContent.replace("UCT", "");

           // Read ticker from ticker element text
           return document.querySelector(".ticker")?.textContent || "";
       },

       spinner: (action, modal) => {
           const spinnerId = modal.dataset.spinnerId;
           
           switch (action) {
               case "init":
                   const rand = Math.round(Math.random() * 100);
                   const newSpinnerId = "veSpinnerForModal" + rand;
                   const spinnerElement = modal.querySelector("#veSpinnerForModal");
                   
                   if (spinnerElement) {
                       spinnerElement.id = newSpinnerId;
                   }
                   
                   doSpinnerByLoadingId(newSpinnerId, null, "ModalSpinner");
                   
                   const modalSpinner = document.querySelector(`#${newSpinnerId} #ModalSpinner`);
                   if (modalSpinner) {
                       modalSpinner.style.display = "none";
                   }
                   
                   modal.dataset.spinnerId = newSpinnerId;
                   break;
                   
               case "show":
                   if (modal.dataset.spinnerId) {
                       const modalSpinner = document.querySelector(`#${spinnerId} #ModalSpinner`);
                       if (modalSpinner) {
                           modalSpinner.style.display = "block";
                           return;
                       }
                   }
                   
                   veBrokerClickOut.spinner("init", modal);
                   veBrokerClickOut.spinner("show", modal);
                   break;
                   
               case "hide":
               default:
                   if (spinnerId) {
                       const modalSpinner = document.querySelector(`#${spinnerId} #ModalSpinner`);
                       if (modalSpinner) {
                           modalSpinner.style.display = "none";
                       }
                   }
                   break;
           }
       },

       //To get the list of brokers from server.
       getBrokerDetails: async (ticker, currentPage, countryISO) => {
           const response = await fetch(`${veBrokerClickOut.APIURL}?tickerName=${encodeURIComponent(ticker)}&currentPage=${encodeURIComponent(currentPage)}&countryISO=${encodeURIComponent(countryISO)}`);
           return await response.json();
       },

       //To render the list of broker links.
       rnBrokers: async (brokerList, containerSelector, modal) => {
           const mkBrokerList = brokerList.reduce((prev, curr) => {
               if (!curr.brokerLink) return prev;
               const mkBroker = document.createElement("li");

               //Has a disclaimer
               if (curr.brokerHaveDisclaimer && curr.brokerDisclaimer) 
                   mkBroker.classList.add('has_disclaimer');

               switch (true) {
                   //Has an image
                   case Boolean(curr.brokerImage):
                       mkBroker.innerHTML = `<a href="${curr.brokerLink}" class="broker-image-${curr.brokerName}" data-gtm-category='broker-clickout' data-gtm-action='click-broker' data-gtm-label='${curr.brokerName}' data-gtm-value='1' target="_blank"><img class="broker-clickout__broker-image" src="${curr.brokerImage}"  alt="${curr.brokerName}"></img></a>`;
                       break;
                   default:
                       mkBroker.classList.add("text");
                       mkBroker.innerHTML = `<a href="${curr.brokerLink}" data-gtm-category='broker-clickout' data-gtm-action='click-broker' data-gtm-label='${curr.brokerName}' data-gtm-value='1' target="_blank">${curr.brokerName}</a>`;
               }
               mkBroker.dataset.brokerData = JSON.stringify(curr);
               prev.push(mkBroker);
               return prev;
           }, []);

           const resultContent = mkBrokerList.length === 0 
               ? await globalTranslationService.translateKey("_FundBlock.BrokerCliskout.No_broker_for_product_disclaimer") || 'No broker is presently linked to this product.'
               : mkBrokerList;

           const containerElement = modal.querySelector(containerSelector);
           if (containerElement) {
               if (typeof resultContent === 'string') {
                   containerElement.textContent = resultContent;
               } else {
                   resultContent.forEach(item => containerElement.appendChild(item));
               }
           }
           
           document.querySelectorAll("li.has_disclaimer").forEach(item => {
               item.addEventListener("click", e => {
                   e.preventDefault();
                   veBrokerClickOut.rnDisclaimer(e.currentTarget);
               });
           });
           
           return true;
       },

       parseEmailLink: (href, ticker, currentPage) => {
           return href.replace("{ticker}", ticker).replace("{currentPage}", encodeURIComponent(currentPage));
       },

       resetModal: () => {
           document.querySelectorAll(".broker-clickout__disclaimer-content").forEach(el => el.remove());
           const mainContent = document.querySelector(".broker-clickout__main");
           if (mainContent) {
               mainContent.style.display = "block";
           }
       },

       rnDisclaimer: async (elem) => {
           if (!elem) return console.error("Couldn't find the broker.");

           const brokerData = JSON.parse(elem.dataset.brokerData);
           if (typeof (brokerData) != "object") return console.error("Error with broker details.");

           const model = elem.closest(".modal.broker-clickout");
           if (model) {
               model.classList.add("no-margin-top");
           }

           const getButtons = (accept, reject, showBoth) => {
               const mkButtons = document.createElement("div");
               mkButtons.classList.add("disclaimer-buttons");
               mkButtons.innerHTML = `<button type='button' class='btn btn-primary' id='broker-btn-accept'>${accept}</button><button type='button' class='btn btn-primary' id='broker-btn-reject'>${reject}</button>`;
               
               if (!showBoth) {
                   const acceptButton = mkButtons.querySelector("#broker-btn-accept");
                   if (acceptButton) {
                       acceptButton.remove();
                   }
               }
               
               return mkButtons;
           };

           const applyEventListeners = (model, brokerLink) => {
               const modal = document.getElementById("id-how-to-buy-etf-modal");
               
               if (brokerLink) {
                   const acceptButton = model.querySelector("#broker-btn-accept");
                   if (acceptButton) {
                       acceptButton.addEventListener("click", e => {
                           window.open(brokerLink, '_blank');
                           veBrokerClickOut.resetModal();
                           
                           if (modal) {
                               const bsModal = bootstrap.Modal.getInstance(modal);
                               if (bsModal) {
                                   bsModal.hide();
                               }
                           }
                       });
                   }
               }
               
               const rejectButton = model.querySelector("#broker-btn-reject");
               if (rejectButton) {
                   rejectButton.addEventListener("click", e => {
                       e.preventDefault();
                       veBrokerClickOut.resetModal();
                       model.classList.remove("no-margin-top");
                   });
               }
               
               if (modal) {
                   modal.addEventListener("hidden.bs.modal", () => {
                       veBrokerClickOut.resetModal();
                   }, { once: true });
               }
               
               return true;
           };

           //1. Hide the existing content.
           const mainContent = document.querySelector(".broker-clickout__main");
           if (mainContent) {
               mainContent.style.display = "none";
           }

           //2. Show the spinner
           const modal = document.getElementById("id-how-to-buy-etf-modal");
           if (modal) {
               veBrokerClickOut.spinner("show", modal);
           }

           //3. Get the disclaimer.
           try {
               const response = await veBrokerClickOut.getBrokerDisclaimer(brokerData.brokerDisclaimer);
               
               //4. Parse
               console.log(response);

               const mkdisclaimer = document.createElement('div');
               mkdisclaimer.classList.add('broker-clickout__disclaimer-content');
               mkdisclaimer.innerHTML = `<h4>${response.title}</h4><p>${response.content}</p>`;

               const modalBody = modal.querySelector(".modal-body");
               if (modalBody) {
                   modalBody.appendChild(mkdisclaimer);
               }

               const disclaimerContent = document.querySelector(".broker-clickout__disclaimer-content");
               if (disclaimerContent) {
                   disclaimerContent.appendChild(getButtons(veDictionary.accept, veDictionary.reject, true));
               }
               
               applyEventListeners(model, brokerData.brokerLink);
           }
           catch (err) {
               console.error("Error getting data: ", err);
               veBrokerClickOut.spinner("hide", modal);
               
               const modalBody = modal.querySelector(".modal-body");
               if (modalBody) {
                   const errorDiv = document.createElement('div');
                   errorDiv.classList.add('broker-clickout__disclaimer-content');
                   errorDiv.innerHTML = "<p>An error occured.</p>";
                   modalBody.appendChild(errorDiv);
               }
               
               const disclaimerContent = document.querySelector(".broker-clickout__disclaimer-content");
               if (disclaimerContent) {
                   disclaimerContent.appendChild(getButtons(veDictionary.accept, veDictionary.back));
               }
               
               applyEventListeners(model);
               return true;
           }

           //n. Hide the spinner
           veBrokerClickOut.spinner("hide", modal);
       },

       getBrokerDisclaimer: async (disclaimerID) => {
           const response = await fetch(`${veBrokerClickOut.APIDisclaimerURL}?brokerDisclaimerBlockId=${encodeURIComponent(disclaimerID)}`);
           return await response.json();
       },

       addBuyNowButtonClickListener: () => {
          document.querySelectorAll(".fund-data-row__main-content .cta-button").forEach(button => {
              if (button.dataset.modalListenerAttached === 'true') return;

              button.addEventListener("click", (e) => {
                  e.preventDefault();
                  console.log(veBrokerClickOut)
                  veBrokerClickOut.ticker = veBrokerClickOut.getTicker(e)?.replace(/^UCT/, ""); // remove `UCT` prefix from ticker;
                  
                  const modal = document.getElementById("id-how-to-buy-etf-modal");
                  if (modal) {
                      const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
                      bsModal.show();
                  }
               });

              button.dataset.modalListenerAttached = 'true';
           });
       },
       
       init: () => {
           const modal = document.getElementById("id-how-to-buy-etf-modal");
           if (!modal) return;

           modal.addEventListener("show.bs.modal", async (e) => {
               if (veBrokerClickOut.ticker === "") {
                   const stickyLinks = Array.from(document.querySelectorAll(".sticky-links a")).filter(item => {
                       return item.getAttribute("data-cssclass")?.includes("how-to-buy");
                   });
                   
                   if (stickyLinks.length > 0) {
                       veBrokerClickOut.ticker = veBrokerClickOut.getTicker(stickyLinks[0]);
                   }
               }
               
               //0. Add no transition class to the parent
               const parent = modal.closest(".fund-data-row__main-content");
               if (parent) {
                   parent.classList.add("no-transition");
               }

               //2. Load the spinner.
               veBrokerClickOut.spinner("show", modal);

               //3. Try get the data.
               try {
                   const response = await veBrokerClickOut.getBrokerDetails(
                       veBrokerClickOut.ticker, 
                       veBrokerClickOut.currentPage, 
                       veBrokerClickOut.countryISO
                   );
                   
                   //4. Parse and load data.
                   if (response) {
                       await veBrokerClickOut.rnBrokers(response, ".broker-clickout__broker-list.show-broker-list", modal);
                   }

                   //5. Inject ticker and URL to the HREF of the anchor email.
                   const emailLink = document.querySelector(".contact-fa a:first-child");
                   if (emailLink) {
                       const emailhref = emailLink.getAttribute("href");
                       if (emailhref?.length) {
                           emailLink.setAttribute("href", veBrokerClickOut.parseEmailLink(emailhref, veBrokerClickOut.ticker, veBrokerClickOut.currentPage));
                       }
                   }

                  //  veBrokerClickOut.addBuyNowButtonClickListener();
               }
               catch (err) {
                   console.error("Error getting data: ", err);
                   const brokerList = modal.querySelector(".broker-clickout__broker-list.show-broker-list");
                   if (brokerList) {
                       brokerList.textContent = "An error occured getting the list of brokers.";
                   }
               }

               //6. Hide the spinner.
               veBrokerClickOut.spinner("hide", modal);
           });

           veBrokerClickOut.addBuyNowButtonClickListener();

           document.querySelectorAll(".id-how-to-buy-etf-modal").forEach(el => {
               el.classList.remove("disabled");
           });

           //Empty out broker list (reset) on modal close (WEBEU-2359)
           modal.addEventListener("hide.bs.modal", () => {
            document.querySelectorAll(".broker-clickout__broker-list").forEach(list => {
                   list.innerHTML = '';
               });
           });

           // listen for table render and add buy now button click listener
           document.addEventListener('FundExplorerTableEvent', (e) => {
               if (e.detail.eventType == 'table-rendered') {
                   veBrokerClickOut.addBuyNowButtonClickListener();
               }
           });
       }
   };

   veBrokerClickOut.init();
}

document.addEventListener('DOMContentLoaded', () => {
   const modalButtons = document.querySelectorAll(".mutual-fund-page .modal-js");
   if (modalButtons.length === 0) return;
   
   modalButtons.forEach(modalButton => {
       const classList = modalButton.getAttribute("class") || "";
       const modalIdMatch = classList.match("id-[^\s]*");
       const modalId = modalIdMatch ? modalIdMatch[0] : null;
       
       if (!modalId) return;
       
       modalButton.addEventListener("click", (e) => {
           e.preventDefault();
           const modal = document.getElementById(modalId);
           
           if (modal) {
               const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
               bsModal.show();
           }
       });
   });

   //Close Fund Page Banner
   document.querySelectorAll(".fund-banner-close-button").forEach(button => {
       button.addEventListener("click", () => {
           const banner = document.querySelector(".fund-banner-wrapper");
           if (banner) {
               banner.style.display = "none";
           }
       });
   });
});

// adjust modal top mobile when buy-now btn is displayed
const buyNowModal = document.getElementById("id-how-to-buy-etf-modal");
if (buyNowModal) {
   buyNowModal.addEventListener("show.bs.modal", (e) => {
       if (window.innerWidth <= 768) {
           const header = document.querySelector("header");
           if (header) {
               const headerHeight = header.offsetHeight;
               e.target.style.paddingTop = headerHeight.toString() + "px";
           }
       } else {
           e.target.style.paddingTop = "unset";
       }
   });
}

const initialHeight = window.innerHeight;
window.addEventListener('resize', debounce(() => {
   const bs4Modal = document.querySelector(".modal-backdrop.fade.show.z-index-998");
   const modal = document.getElementById("id-how-to-buy-etf-modal");
   
   if (bs4Modal && window.innerWidth <= 768 && modal) {
       const header = document.querySelector("header");
       if (header) {
           const headerHeight = header.offsetHeight;
           modal.style.paddingTop = headerHeight.toString() + "px";
       }
   } else if (modal) {
       modal.style.paddingTop = "unset";
   }

   // if safari and bottom nav visible, add a margin-bottom
   const agent = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
   if ((agent && agent !== undefined) || agent !== null) {
       if (modal) {
           if (window.innerHeight == initialHeight) {
               modal.classList.add("safari-bottom-nav-opened");
           } else {
               modal.classList.remove("safari-bottom-nav-opened");
           }
       }
   }
}, 100));

// adjust modal z-index to display header on mobile when buy-now btn is displayed
if (buyNowModal) {
   buyNowModal.addEventListener("shown.bs.modal", (e) => {
       document.querySelectorAll(".modal-backdrop.fade.show").forEach(backdrop => {
           backdrop.classList.add("z-index-998");
       });
       e.target.classList.add("z-index-999");
   });

   buyNowModal.addEventListener("hide.bs.modal", (e) => {
       document.querySelectorAll(".modal-backdrop.fade.show").forEach(backdrop => {
           backdrop.classList.remove("z-index-998");
       });
       e.target.classList.remove("z-index-999");
   });
}

// remove min-height from big screens when form is hidden
if (document.getElementById("id-how-to-buy-etf-modal")) {
   const form = document.querySelector("#id-how-to-buy-etf-modal .how-to-buy-popup-subscriptions-form");
   const content = document.querySelector("#id-how-to-buy-etf-modal .modal-content");
   
   if (content) {
       if (form) {
           content.classList.add("set-min-height");
       } else {
           content.classList.remove("set-min-height");
       }
   }
}